import { createContext } from 'react'
import { defaultColorScheme } from '@helpers/color_scheme_helpers.js'

export const ThemeContext = createContext(defaultColorScheme())
